/* eslint-disable react-hooks/exhaustive-deps */
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { ExecutionMain } from './components/execution-main.component';

export const ExecutionComponent = () => {
	const planningProject = useSelector((state: RootState) => state.profileProject);
	return <>{planningProject.stepEjecucion === 0 && <ExecutionMain />}</>;
};
